import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { claimTypeApi } from '@/main/api';
import { saveClaimType } from './index';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

// Api's

export function* getClaimTypeSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      claimTypeApi.getDomain
    );

    if (response.data.result) {
      yield put(saveClaimType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveClaimType(null, true, resultError.messagesDataError));
    }
  }
}
